export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const RAZORPAY_KEY_ID = process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID;